//预正式服
module.exports = {
  baseUrl: 'http://test.manage2.cleverplanting.com/'
}